const formatMoney = (amount: number, currency = 'USD'): string =>
	Intl.NumberFormat('en-US', {
		currency,
		style: 'currency',
	}).format(amount);

export default formatMoney;
